import {FC} from 'react';
import {Control, Controller} from 'react-hook-form';
import {ITotpForm} from 'core';
import {Input} from 'ui-kit';

interface IProps {
  control: Control<ITotpForm>;
}

export const TotpFieldsForm: FC<IProps> = ({control}) => {
  return (
    <Controller
      control={control}
      name={'totp_code'}
      rules={{required: true, minLength: 6, maxLength: 6}}
      render={({field: {onChange, value}}) => {
        return (
          <Input
            value={value}
            autoComplete={'one-time-code'}
            placeholder={'Enter 6-digit code'}
            onChange={(e) => {
              onChange(e.target.value);
            }}
          />
        );
      }}
    />
  );
};
